/**
 * NOTE: The order of the languages in this list is important because it determines the order
 * in which they are displayed in language selector components. The main customer languages
 * (English, German, and Chinese) are listed first, followed by other supported languages in
 * alphabetical order.
 *
 * @See {@link https://zeiss.atlassian.net/wiki/spaces/CIP/pages/185709911/ZEISS+ID+2.0+Supported+languages+for+user+journeys | Supported languages}
 */
export const supportedLanguages = [
  'en',
  'de',
  'zh-Hans',
  'zh-Hant',
  'ar',
  'cs',
  'da',
  'es',
  'fi',
  'fr',
  'hu',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pl',
  'pt',
  'pt-BR',
  'sk',
  'sv',
  'tr',
] as const;
export type Language = (typeof supportedLanguages)[number];

/**
 * Mapping of supported languages to BCP47 language tags for server requests.
 * Some backend services depend on this mapping to return localized content based on the user's preferred language.
 * @see {@link https://dev.azure.com/ZEISSgroup/ZEISS%20ID/_git/identity.fe?path=/apps/access-management/src/components/journey/Panel.tsx&version=GT0.42.0&line=41&lineEnd=48&lineStartColumn=1&lineEndColumn=4&lineStyle=plain&_a=contents | langLocaleMap}
 */
export const langLocaleMap: Record<Language, string> = {
  ar: 'ar',
  cs: 'cs-CZ',
  da: 'da-DK',
  de: 'de-DE',
  en: 'en-US',
  es: 'es-ES',
  fi: 'fi-FI',
  fr: 'fr-FR',
  hu: 'hu-HU',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  nl: 'nl-NL',
  no: 'no-NO',
  pl: 'pl-PL',
  pt: 'pt-PT',
  'pt-BR': 'pt-BR',
  sk: 'sk-SK',
  sv: 'sv-SE',
  tr: 'tr-TR',
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
};
